// The backend answers errors with {"detail": "..."}; the fetch wrapper hands the raw body back.
export default function readApiError(error) {
    try {
        const body = typeof error?.body === "string" ? JSON.parse(error.body) : null;
        if (typeof body?.detail === "string") return body.detail;
    } catch (e) {
        // not JSON: fall through
    }
    return error?.status ? `The server answered with an error (${error.status}).` : "The server could not be reached.";
}
